"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classifyMemberInfoError = classifyMemberInfoError;
const errors_1 = require("../errors");
/** Классификация ошибок wire `mi` (MEMBER_INFO). */
function classifyMemberInfoError(error) {
    if (!(error instanceof errors_1.FourPdaError) || error.command !== 'mi') {
        return null;
    }
    if (error.code === 2) {
        return 'access_denied';
    }
    if (error.code === 3) {
        const msg = error.message.toLowerCase();
        if (msg.includes('аргумент') || msg.includes('argument')) {
            return 'invalid_member_id';
        }
        return 'member_not_found';
    }
    return null;
}
